import { Stack } from '@fluentui/react';
import React, { useEffect } from 'react';
import { useStore } from '../../../stores/root';
import OperationsWorkspace from '../../../components/operationals/workspace';
import { faClipboardCheck, faHome } from '@fortawesome/pro-light-svg-icons';

const OperationsWorkspacePage: React.FC = () => {
    const { topbar } = useStore();

    useEffect(() => {
        topbar.show("Operations Workspace", [
            { key: "home", icon: faHome, href: "/" },
            { key: "operationals", text: 'Operationals' },
            { key: "operations", text: 'Operations Workspace' }
        ]);
    }, []);

    return (
        <Stack styles={{ root: { padding: '10px 0' } }}>
            <OperationsWorkspace />
        </Stack>
    );
};

export default OperationsWorkspacePage;
